import InputNumber from './src/input-number.mjs';
export { inputNumberEmits, inputNumberProps } from './src/input-number2.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElInputNumber = withInstall(InputNumber);

export { ElInputNumber, ElInputNumber as default };
//# sourceMappingURL=index.mjs.map
